/* Fraquane: light, depth and a responsive wolf. The original selector handles preferences. */
(() => {
  'use strict';
  const root = document.querySelector('[data-fqm-root]');
  if (!root) return;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(pointer: fine)');
  const scene = root.querySelector('[data-fqm-scene]');
  const stage = root.querySelector('[data-fqm-wolf-stage]');
  const wolf = root.querySelector('[data-fqm-wolf]');
  const note = root.querySelector('.fqm-note');
  const motionButton = root.querySelector('[data-fqm-motion]');
  const canvas = root.querySelector('[data-fqm-particles]');
  const ctx = canvas && canvas.getContext('2d', { alpha: true });
  const query = new URLSearchParams(location.search);
  root.querySelectorAll('[data-fqm-career], .fqm-brand').forEach(link => {
    const target = new URL(link.getAttribute('href'), location.origin);
    ['preview_theme_id', 'pb', '_fd', '_sc'].forEach(key => {
      if (query.has(key)) target.searchParams.set(key, query.get(key));
    });
    link.href = target.pathname + target.search;
  });
  let paused = false, raf = 0, frameTime = 0, lastTime = 0, clock = 0;
  let width = 1, height = 1, rootBounds, stageBounds, noteBounds, reactionTimer = 0;
  const pointer = { x: -9999, y: -9999, active: false };
  const tilt = { x: 0, y: 0, targetX: 0, targetY: 0 };
  let stars = [], sparks = [], rings = [];
  try { paused = localStorage.getItem('fq_maintenance_motion') === 'paused'; } catch (_) {}
  const still = () => paused || reducedMotion.matches || document.hidden;

  function measureBounds() {
    rootBounds = root.getBoundingClientRect();
    stageBounds = stage && stage.getBoundingClientRect();
    noteBounds = note && note.getBoundingClientRect();
  }
  function measure() {
    measureBounds();
    width = Math.max(1, rootBounds.width); height = Math.max(1, rootBounds.height);
    if (!ctx) return;
    const ratio = Math.min(devicePixelRatio || 1, 1.5);
    canvas.width = Math.round(width * ratio); canvas.height = Math.round(height * ratio);
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    stars = Array.from({ length: width < 761 ? 40 : 78 }, () => ({
      x: Math.random() * width, y: Math.random() * height, size: .45 + Math.random() * 1.1,
      phase: Math.random() * Math.PI * 2, speed: .1 + Math.random() * .3, drift: (Math.random() - .5) * .12
    }));
  }
  function requestFrame() { if (!raf && !still()) raf = requestAnimationFrame(draw); }
  function updateMotion() {
    const stopped = still();
    root.classList.toggle('is-paused', stopped);
    document.body.classList.toggle('fqm-motion-paused', stopped);
    root.classList.toggle('has-fqm-motion', !reducedMotion.matches);
    if (motionButton) {
      motionButton.hidden = reducedMotion.matches;
      motionButton.setAttribute('aria-pressed', String(paused));
      const label = paused ? motionButton.dataset.resume : motionButton.dataset.pause;
      motionButton.setAttribute('aria-label', label); motionButton.title = label;
      motionButton.querySelector('[data-fqm-pause-icon]').hidden = paused;
      motionButton.querySelector('[data-fqm-play-icon]').hidden = !paused;
    }
    if (stopped) {
      cancelAnimationFrame(raf); raf = 0; lastTime = 0;
      if (scene) { scene.style.setProperty('--fqm-x', '0px'); scene.style.setProperty('--fqm-y', '0px'); }
      tilt.targetX = tilt.targetY = 0;
    } else requestFrame();
  }
  function draw(time) {
    raf = 0;
    if (still()) return;
    if (time - frameTime < 32) { requestFrame(); return; }
    const step = lastTime ? Math.min((time - lastTime) / 16.67, 3) : 1;
    frameTime = time; lastTime = time; clock += step;
    tilt.x += (tilt.targetX - tilt.x) * .09; tilt.y += (tilt.targetY - tilt.y) * .09;
    if (scene) {
      scene.style.setProperty('--fqm-x', (tilt.x * -9).toFixed(2) + 'px');
      scene.style.setProperty('--fqm-y', (tilt.y * -6).toFixed(2) + 'px');
    }
    if (stage) {
      stage.style.setProperty('--fqm-wolf-x', (tilt.x * 12).toFixed(2) + 'px');
      stage.style.setProperty('--fqm-wolf-y', (tilt.y * 8).toFixed(2) + 'px');
      stage.style.setProperty('--fqm-rotate-x', (tilt.y * -3).toFixed(2) + 'deg');
      stage.style.setProperty('--fqm-rotate-y', (tilt.x * 4).toFixed(2) + 'deg');
    }
    if (!ctx) { requestFrame(); return; }
    ctx.clearRect(0, 0, width, height);
    for (const star of stars) {
      star.y -= star.speed * step; star.x += star.drift * step;
      if (star.y < -10) star.y = height + 10;
      if (star.x < -10) star.x = width + 10;
      if (star.x > width + 10) star.x = -10;
      let x = star.x, y = star.y;
      const dx = pointer.x - x, dy = pointer.y - y, distance = Math.hypot(dx, dy);
      const near = pointer.active && distance < 170;
      if (near) {
        const pull = (1 - distance / 170) * .09;
        x += dx * pull; y += dy * pull;
        if (distance < 100) {
          ctx.strokeStyle = 'rgba(150,194,255,' + ((1 - distance / 100) * .13) + ')'; ctx.lineWidth = .5;
          ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(pointer.x, pointer.y); ctx.stroke();
        }
      }
      const alpha = .16 + (Math.sin(clock * .017 + star.phase) + 1) * .16 + (near ? .35 : 0);
      ctx.fillStyle = 'rgba(180,213,255,' + alpha + ')';
      ctx.beginPath(); ctx.arc(x, y, star.size + (near ? .45 : 0), 0, Math.PI * 2); ctx.fill();
    }
    sparks = sparks.filter(spark => spark.life > 0);
    for (const spark of sparks) {
      spark.life -= .014 * step; spark.x += spark.vx * step; spark.y += spark.vy * step;
      spark.vx *= .984; spark.vy = spark.vy * .984 - .008 * step;
      ctx.fillStyle = 'rgba(' + spark.tone + ',' + Math.max(0, spark.life * .8) + ')';
      ctx.beginPath(); ctx.arc(spark.x, spark.y, Math.max(.3, spark.life * spark.size), 0, Math.PI * 2); ctx.fill();
    }
    rings = rings.filter(ring => ring.life > 0);
    for (const ring of rings) {
      ring.life -= .016 * step; ring.radius += 2.5 * step;
      ctx.strokeStyle = 'rgba(164,205,255,' + Math.max(0, ring.life * .48) + ')'; ctx.lineWidth = .8;
      ctx.beginPath(); ctx.ellipse(ring.x, ring.y, ring.radius, ring.radius * .43, -.12, 0, Math.PI * 2); ctx.stroke();
    }
    requestFrame();
  }
  function react(event) {
    if (still() || !stage) return;
    measureBounds();
    const x = event && event.clientX ? event.clientX - rootBounds.left : stageBounds.left - rootBounds.left + stageBounds.width * .5;
    const y = event && event.clientY ? event.clientY - rootBounds.top : stageBounds.top - rootBounds.top + stageBounds.height * .53;
    for (let i = 0, amount = width < 761 ? 30 : 46; i < amount; i++) {
      const angle = Math.random() * Math.PI * 2, speed = .6 + Math.random() * 2.3;
      sparks.push({ x, y, vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed, life: .7 + Math.random() * .3, size: 1.2 + Math.random() * 1.7, tone: i % 4 ? '170,212,255' : '202,183,255' });
    }
    sparks = sparks.slice(-120); rings.push({ x, y, radius: 10, life: 1 }); rings = rings.slice(-4);
    clearTimeout(reactionTimer); stage.classList.remove('is-awake');
    requestAnimationFrame(() => stage.classList.add('is-awake'));
    stage.dataset.fqmReactions = String(Number(stage.dataset.fqmReactions || 0) + 1);
    reactionTimer = setTimeout(() => stage.classList.remove('is-awake'), 1900);
    requestFrame();
  }
  root.addEventListener('pointermove', event => {
    if (still()) return;
    pointer.x = event.clientX - rootBounds.left; pointer.y = event.clientY - rootBounds.top; pointer.active = true;
    if (finePointer.matches) {
      tilt.targetX = (event.clientX / innerWidth - .5) * 2; tilt.targetY = (event.clientY / innerHeight - .5) * 2;
      root.style.setProperty('--fqm-pointer-x', pointer.x.toFixed(0) + 'px');
      root.style.setProperty('--fqm-pointer-y', pointer.y.toFixed(0) + 'px');
      root.style.setProperty('--fqm-pointer-active', '1');
      root.style.setProperty('--fqm-title-light', (event.clientX / innerWidth * 100).toFixed(0) + '%');
      if (note && noteBounds) {
        note.style.setProperty('--fqm-note-x', ((event.clientX - noteBounds.left) / noteBounds.width * 100).toFixed(1) + '%');
        note.style.setProperty('--fqm-note-y', ((event.clientY - noteBounds.top) / noteBounds.height * 100).toFixed(1) + '%');
      }
    }
  }, { passive: true });
  root.addEventListener('pointerleave', () => { pointer.active = false; tilt.targetX = tilt.targetY = 0; root.style.setProperty('--fqm-pointer-active', '0'); });
  if (wolf) wolf.addEventListener('click', react);
  if (motionButton) motionButton.addEventListener('click', () => {
    paused = !paused;
    try { localStorage.setItem('fq_maintenance_motion', paused ? 'paused' : 'running'); } catch (_) {}
    updateMotion();
  });
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', updateMotion);
  else if (reducedMotion.addListener) reducedMotion.addListener(updateMotion);
  document.addEventListener('visibilitychange', updateMotion);
  addEventListener('scroll', measureBounds, { passive: true });
  addEventListener('resize', measure, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(root);
  measure(); updateMotion();
})();
